import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router";
import { getPerformaInvoiceById, updatePerformaInvoice } from "../../actions/PerformaInvoiceActions";
import Webmenu from "../../layouts/webmenu";
import Topbar from "../../layouts/topbar";
import Mobilemenu from "../../layouts/mobile-menu";

function PerformaInvoiceDetail() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const params = useParams();

    useEffect(() => {
            dispatch(getPerformaInvoiceById(params.id));
         }, []);
    
    const performaInvoice = useSelector(state => state?.performaInvoices?.performaInvoice);
    
    const update = () => {
            dispatch(updatePerformaInvoice(params.id));
            navigate('/performaInvoices');
        }
    // performaInvoice)
    return (
        <React.Fragment>
        <Mobilemenu />
            <div className="content-body d-flex">
                <Webmenu />
                <div className="content">
                    <Topbar />
                    {/* Edit Vehicle Modal */}
                    <div className="intro-y box">
                        <div className="p-3">
                            <div className="grid columns-12">
                                <div className="g-col-12 g-col-sm-6">
                                    <h2 className="fs-xl fw-medium">{performaInvoice.length > 0 ? performaInvoice[0].order_partner_id : ''}</h2>
                                    {/* <h2 className="fs-lg text-gray-700">{performaInvoice.length > 0 ? performaInvoice[0].order_partner_id : ''}</h2> */}
                                </div>
                                <div className="g-col-12 g-col-sm-12">
                                    <div class="overflow-x-auto border my-5 border-gray-600 rounded-3">
                                        <table class="table table-striped">
                                            <thead>
                                                <tr>
                                                    <th class="text-nowrap">S. No</th>
                                                    <th class="text-nowrap">Item</th>
                                                    <th class="text-nowrap">Product Name</th>
                                                    <th class="text-nowrap">Price Total</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    performaInvoice && performaInvoice.length > 0 &&
                                                    performaInvoice.map((detail, index) => {
                                                        return (
                                                            <tr>
                                                                <td>{index + 1}</td>
                                                                <td>{detail?.product_id}</td>
                                                                <td>{detail?.name}</td>
                                                                <td>AED {detail?.price_total}</td>
                                                            </tr>
                                                        )
                                                    })
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="g-col-sm-12 d-flex justify-content-end">
                                        <button type="button" onClick={update} className="btn btn-primary w-32 me-1">Create Invoice</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <button type="button" className="btn btn-primary w-32 me-1">Print Job Card</button>
                                                    <button type="button" className="btn btn-primary w-32 me-1">Print Estimate</button> */}
        </React.Fragment>
    )
}

export default PerformaInvoiceDetail;